import FbIcon from "@/icons/facebook-icon.svg";
import TwitterIcon from "@/icons/twitter-icon.svg";
import InstagramIcon from "@/icons/instagram-icon.svg";
import LinkedInIcon from "@/icons/linkedIn-icon.svg";
import MediumIcon from "@/icons/medium-icon.svg";
import { getTranslation } from "@/i18n/get-translation";
import { IBlog } from "@/types/blog.type";
import { ITag } from "@/types/tag.type";


interface ITags {
  locale: string;
  tags: ITag[];
}
export default function Tags({ locale, tags }: ITags) {
  const t = getTranslation(locale, "tags");
  return (
    <section className="mx-auto xl:px-60 lg:px-48 px-20 max-md:px-7 w-full pb-8 lg:pt-4">
      <div className="flex lg:flex-row flex-col lg:justify-between justify-start lg:items-center items-start  gap-y-6">
        {/* Tags */}
        <div className="flex lg:flex-row flex-col justify-start lg:items-center items-start gap-2">
          <span className="text-base font-medium">{t("tags")}: </span>
          <ul
            className="flex list-none pl-0 flex-row gap-[6px] overflow-auto customOverflow"
            role="tablist"
            data-te-nav-ref
          >
            {tags.map((item) => (
              <li role="presentation" key={item.attributes.title}>
                <button
                  type="button"
                  className="block min-w-[4.5rem] w-full rounded-lg bg-primary-500 hover:bg-primary-700 hover:text-white px-4 py-[0.25rem] text-base font-normal text-primary-800 whitespace-nowrap"
                  data-te-toggle="pill"
                  data-te-nav-active
                  role="tab"
                  aria-selected="true"
                >
                  {item.attributes.title}
                </button>
              </li>
            ))}
          </ul>
        </div>
        {/* Social */}
        <div className="flex lg:flex-row flex-col justify-start lg:items-center items-start gap-2">
          <span className="text-base font-medium">Share: </span>
          <ul className="flex list-none pl-0 flex-row gap-[6px] overflow-auto customOverflow">
            <li>
              <a href="#">
                <FbIcon />
              </a>
            </li>
            <li>
              <a href="#">
                <TwitterIcon />
              </a>
            </li>
            <li>
              <a href="#">
                <InstagramIcon />
              </a>
            </li>
            <li>
              <a href="#">
                <LinkedInIcon />
              </a>
            </li>
            <li>
              <a href="#">
                <MediumIcon />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}
